// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"260":"e752d12a","424":"3cd7aea8","453":"c443be68","508":"f03d61d8","567":"b833a8da","701":"62e2f644","715":"cdb83713","848":"b1a9462b"}[chunkId] + ".chunk.js";
};